<template>
	<!--PC端菜单-->
	<div>
	  	<div class="header chl">
			<a class="logo pull-left" @click="enterIndex"><img src="../../assets/images/1.png" alt=""></a>
			<ul class="topNan pull-left visible-lg">
				<li><a @click="enterIndex">Home</a></li>
				<li><a @click="enterProduct">Product</a></li>
				<li><a @click="enterAbout">About us</a></li>
				<li><a @click="enterContactUs">Contact us</a></li>
			</ul>
			<div class="pull-right h-div">
				<div class="pull-left visible-lg">
					<form action="#">
						<div class="formDiv ovh">
							<input type="text" placeholder="" v-model="searchName">
							<input type="search" value="" @click="entrSearch">
						</div>
					</form>
				</div>
				<a v-if="!isShowWap" @click="switchWap" class="but hidden-lg"></a>
				<a v-if="isShowWap" @click="closeWap" class="but hidden-lg cur"></a>
			</div>
	  	</div>
	  	<!--PC端菜单END-->
	
	  	<!--移动端菜单-->
		<div v-if="isShowWap" class="wapDiv">
			<ul class="topNan2">
				<li><a @click="enterIndex">Home</a></li>
				<li><a @click="enterProduct">Product</a></li>
				<li><a @click="enterAbout">About us</a></li>
				<li><a @click="enterContactUs">Contact us</a></li>
			</ul>
			<form action="#" class="c-b form2">
				<div class="formDiv ovh">
					<input type="text" placeholder="">
					<input type="search" value="">
				</div>
			</form>
		</div>
		<!--移动端菜单END-->
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
    	isShowWap:false,
    	searchName:''
    }
  },
  watch: {

  },
  mounted () {

  },
  methods: {
    getHeight () {
      	this.$emit("sendHeight", $(".header").css("height"))
    },
    enterIndex() {
    	this.isShowWap = false;
      	this.$router.push({ path: '/cetd/index' })
    },
    enterProduct() {
    	this.isShowWap = false;
      	this.$router.push({ path: '/cetd/product' })
    },
    enterAbout(){
    	this.isShowWap = false;
      	this.$router.push({ path: '/cetd/about' })
    },
    enterContactUs(){
    	this.isShowWap = false;
    	this.$router.push({ path: '/cetd/contactUs' })
    },
    entrSearch(){
    	this.$router.push({ 
    		path: '/cetd/search',
    	    query: {searchName: this.searchName}
        })
    },
    switchWap(){
    	this.isShowWap = true;
    },
    closeWap(){
    	this.isShowWap = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/layout/components/Header.vue